.modal { width: min(80rem, 70vw); }

.row {
  padding-top: 16px;
  padding-left: 24px;
  padding-right: 24px;
  padding-bottom: 16px;
}

.rowHeader { margin-top: 0px; }
.savedTemplatesButton:hover { background: none !important; }
.savedTemplatesButton {
  padding-top: 16px;
  padding-bottom: 16px;
  margin-top: -16px;
  margin-bottom: -16px;
}

.checkedRadioBox {
/*  background: linear-gradient(to right, rgba(223, 56, 0,0.15), transparent);*/
  background: var(--static-background-weak) !important;
}
.radioBox {
/*  background: linear-gradient(to right, transparent, transparent);*/
  background: transparent;
  transition: background 100ms ease-out;
}